import { configureStore } from '@reduxjs/toolkit'
import { save, load } from 'redux-localstorage-simple'

import rootReducer from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    save({
      states: ['drafts'],
      namespace: 'redux'
    })
  ),
  preloadedState: load({
    states: ['drafts'],
    namespace: 'redux'
  }),
})

export default store
